"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineaTestnet = void 0;
const chainExplorerLink_1 = require("../../helpers/chainExplorerLink");
const lineaExplorerUrl = 'https://explorer.goerli.linea.build';
exports.LineaTestnet = {
    chainId: 59140,
    chainName: 'Linea Testnet',
    isTestChain: true,
    isLocalChain: false,
    multicallAddress: '0x9901f3053527a58B8C210B144f53CbeA7b6E23Fb',
    rpcUrl: 'https://rpc.goerli.linea.build',
    nativeCurrency: {
        name: 'Linea Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    blockExplorerUrl: lineaExplorerUrl,
    getExplorerAddressLink: (0, chainExplorerLink_1.getAddressLink)(lineaExplorerUrl),
    getExplorerTransactionLink: (0, chainExplorerLink_1.getTransactionLink)(lineaExplorerUrl),
};
exports.default = { LineaTestnet: exports.LineaTestnet };
//# sourceMappingURL=linea.js.map